/**
 * Translations for the imagine feature area.
 */
const imagine = {
  zh: {
    'imagine.title': '💭 无限遐想',
    'imagine.subtitle': '写下你心里的动物世界',
    'imagine.hero.headline': '这里没有对错，只有想象',
    'imagine.hero.body1': '你想要什么样的动物？什么样的世界？',
    'imagine.hero.body2': '写下来吧，也许有一天它就真的出现了。',
    'imagine.hero.cta': '✍️ 写一个新的想象',
    'imagine.tips.title': '💡 今天的小灵感',
    'imagine.tips.helper': '点一条开始写 ↓',
    'imagine.placeholder': '随便写，天马行空... 你的世界多大都可以 🌌',
    'imagine.save': '💾 保存想象',
    'imagine.empty.required': '写点什么吧～',
    'imagine.list.heading': '🌌 你以前的世界（{n}）',
    'imagine.list.empty': '还没有任何想象，写第一个吧 👆',
    'imagine.error.fallback': '出错了',
    'imagine.prompt.1': '如果你能发明一种新的动物，它会是什么样子？',
    'imagine.prompt.2': '你梦想的宠物乐园在哪里？是在天空还是海底？',
    'imagine.prompt.3': '你想让仓鼠和狗狗做什么有趣的事情？',
    'imagine.prompt.4': '如果宠物能说话，你最想听它说什么？',
    'imagine.prompt.5': '你想见到的最大的动物是什么？最小的呢？',
    'imagine.prompt.6': '你的宠物今天做了一个梦，梦到了什么呢？',
    'imagine.prompt.7': '如果可以去一个地方和所有动物交朋友，你想去哪里？',
    'imagine.prompt.8': '想象一下下雪天，动物们会穿什么衣服？',
  } as Record<string, string>,
  en: {
    'imagine.title': '💭 Imagination',
    'imagine.subtitle': 'Write down the animal world inside your head',
    'imagine.hero.headline': 'No right or wrong here — only imagination',
    'imagine.hero.body1': 'What kind of animal do you want? What kind of world?',
    'imagine.hero.body2': "Write it down — maybe one day it'll come true.",
    'imagine.hero.cta': '✍️ Write a new imagination',
    'imagine.tips.title': "💡 Today's spark",
    'imagine.tips.helper': 'Tap one to start writing ↓',
    'imagine.placeholder': 'Write anything you like — your world can be as big as you want 🌌',
    'imagine.save': '💾 Save it',
    'imagine.empty.required': 'Write something first ～',
    'imagine.list.heading': '🌌 Your past worlds ({n})',
    'imagine.list.empty': 'No imaginations yet — write your first one 👆',
    'imagine.error.fallback': 'Something went wrong',
    'imagine.prompt.1': 'If you invented a new animal, what would it look like?',
    'imagine.prompt.2': 'Where is your dream pet park — in the sky or under the sea?',
    'imagine.prompt.3': 'What fun things would you make a hamster and a dog do together?',
    'imagine.prompt.4': 'If pets could talk, what would you most want to hear them say?',
    'imagine.prompt.5': "What's the biggest animal you'd love to meet? The smallest?",
    'imagine.prompt.6': 'Your pet had a dream today — what did it dream about?',
    'imagine.prompt.7': 'If you could visit one place to befriend every animal, where would you go?',
    'imagine.prompt.8': 'Imagine a snowy day — what would the animals wear?',
  } as Record<string, string>,
};

export default imagine;
